module.exports = __webpack_public_path__ + "static/media/result_success.cf61fc8e.mp4";